// SPDX-License-Identifier: AGPL-3.0-or-later

export interface PollOption {
	id: string;
	text: string;
	emoji: string;
}

export interface PollData {
	question: string;
	options: Array<PollOption>;
	allowMultiple: boolean;
	expiresAt: number; // Unix timestamp in ms
	closed?: boolean;
}

const POLL_BLOCK_REGEX = /:::poll\s*([\s\S]*?)\s*:::/;

export const DEFAULT_POLL_EMOJIS = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];

export function parsePollData(content: string | undefined | null): PollData | null {
	if (!content) return null;
	const match = POLL_BLOCK_REGEX.exec(content);
	if (!match) return null;
	try {
		const parsed = JSON.parse(match[1]);
		if (
			parsed &&
			typeof parsed.question === 'string' &&
			Array.isArray(parsed.options) &&
			parsed.options.length >= 2
		) {
			return parsed as PollData;
		}
	} catch {
		// Non-JSON or corrupted poll block
	}
	return null;
}

export function stripPollData(content: string | undefined | null): string {
	if (!content) return '';
	return content.replace(POLL_BLOCK_REGEX, '').trim();
}

export function formatPollMessage(poll: PollData): string {
	const header = `📊 **Poll: ${poll.question}**`;
	const block = `:::poll\n${JSON.stringify(poll)}\n:::`;
	return `${header}\n\n${block}`;
}

export function updatePollClosed(content: string, closed = true): string {
	const poll = parsePollData(content);
	if (!poll) return content;
	poll.closed = closed;
	const header = stripPollData(content);
	const block = `:::poll\n${JSON.stringify(poll)}\n:::`;
	return header ? `${header}\n\n${block}` : block;
}
